<script>
import Lightpick from 'lightpick'

const defaultOpts = {
  format: 'DD MMM YYYY',
  numberOfMonths: 2,
  tooltipNights: true,
  minDays: 2,
}

export default {
  props: {
    value: { type: String, default: '' },
    options: { type: Object, default: () => ({}) },
  },
  computed: {
    opts() {
      return Object.assign({}, defaultOpts, this.options)
    },
  },
  mounted() {
    const vm = this
    const opts = this.opts

    if (opts.onSelect) {
      const old = opts.onSelect
      opts.onSelect = function(date, endDate) {
        old(...arguments)
        vm.change(date.format(opts.format))
      }
    } else {
      opts.onSelect = function(date, endDate) {
        vm.change(date.format(opts.format))
      }
    }

    opts.field = this.$el

    this.lightpick = new Lightpick(opts)
  },
  beforeDestroy() {
    this.lightpick.destroy()
  },
  methods: {
    change(value) {
      this.$emit('input', value)
    },
    show() {
      this.lightpick.show()
    },
    hide() {
      this.lightpick.hide()
    },
  },
}
</script>

<template>
  <input type="text" class="input cursor-pointer" :value="value" readonly />
</template>
